import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import { DOMAIN } from '../../../../config';
import { useAuthProfileContext } from '../../../../providers/AuthProfileProvider';
import { useCurrentUser } from '../../../../queries/use-current-user';
import OnboardingSidebar from '../../OnboardingSidebar';
import OnboardingStep from '../../OnboardingStep';
import OnboardingStepPreview from '../../OnboardingStepPreview';
import ExistingFirmSelect from './ExistingFirmSelect';
import FirmInvitations from './FirmInvitations';

type JoinFirmProps = {
    onCreate: () => void;
};

function JoinFirm({ onCreate }: JoinFirmProps): JSX.Element {
    const profile = useAuthProfileContext();
    // Get the users firms
    const userQuery = useCurrentUser(profile[`${DOMAIN}/uuid`]);

    if (!userQuery.isSuccess) {
        return <>Loading...</>;
    }

    const user = userQuery.data.user;

    return (
        <>
            <OnboardingSidebar>
                <OnboardingStepPreview
                    title="Your firm"
                    description={'Select an existing firm or new firm to join'}
                    icon={<BuildingOfficeIcon />}
                    active
                />
            </OnboardingSidebar>
            <OnboardingStep
                title="Let's join your firm"
                description={
                    <>
                        Here you can see firms you have already joined, and firms you have been invited to but
                        <br />
                        are yet to join.
                    </>
                }
            >
                <div className="flex flex-col gap-8 max-w-[600px]">
                    <ExistingFirmSelect user={user} />
                    <FirmInvitations />
                    <p className="text-sm text-contentSecondary">
                        Looking to start your own firm?{' '}
                        <button className="text-primary font-medium" onClick={onCreate}>
                            Create a firm
                        </button>
                    </p>
                </div>
            </OnboardingStep>
        </>
    );
}

export default JoinFirm;
